import apiConfig from "../../config/apiConfig";
import { Tokens } from "../../constants";
import { objToQueryString, showSuccessToasts } from "../../services/helpers/Helper";
import { END_POINT, SETTING_PAGE_TYPE } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const setMethodSettingPage = (type) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_METHOD,
         payload: type
      })
   };

export const setTypeCommentPost = (type) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_TYPE_COMMENT,
         payload: type
      })
   };

export const setMessageAddCart = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_MESSAGE_ADD_CART,
         payload: string
      })
   };

export const setButtonAddCart = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_BUTTON_ADD_CART,
         payload: string
      })
   };

export const setButtonOutOfStock = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_HAS_MESSAGE_OUT_OF_STOCK,
         payload: string
      })
   };

export const setButtonLimitCommentPost = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_LIMIT_COMMENT_POST,
         payload: string
      })
   };

export const setButtonIsReplyComment = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_IS_REPLY_COMMENT,
         payload: string
      })
   };

export const setMessageConfirmCart = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_MESSAGE_CONFIRM_CART,
         payload: string
      })
   };

export const setButtonViewCart = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_BUTTON_VIEW_CART,
         payload: string
      })
   };

export const setContentMessageOutOfStockCart = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_CONTENT_MESSAGE_OUT_OF_STOCK,
         payload: string
      })
   };

export const setMessageGuide = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_MESSAGE_GUIDE,
         payload: string
      })
   };

export const setIsBuyingGuide = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_IS_BUYING_GUIDE,
         payload: boolean
      })
   };

export const setMessageCommentOrder = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_MESSAGE_COMMENT_ORDER,
         payload: string
      })
   }

export const fetchSettingPageInfo = (campaign_id = 0) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime(),
         campaign_cate: 1,
         campaign_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.PAGE_SETTING_INFO}?${qs}`
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: SETTING_PAGE_TYPE.FETCH,
            payload: response.data
         })
      }).catch((error) => {
         dispatch(setError(error.message))
      })
   };

export const postSettingPageInfo = (campaign_id = 0) =>
   async (dispatch, getState) => {
      const { settingPage, page } = getState();
      const params = {
         ...settingPage,
         // message_comment_order: JSON.stringify([]),
         fb_page_id: page.social_id,
         campaign_cate: 1,
         campaign_id
      }
      dispatch(showLoading());
      return apiConfig.post(END_POINT.PAGE_SETTING, params).then((response) => {
         showSuccessToasts('Lưu cấu hình thành công');
         return Promise.resolve(response);
      }).catch((error) => {
         dispatch(setError(error.message))
      }).finally(() => dispatch(hideLoading()));
   };

export const seHasAddProductToDraftOrders = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_HAS_ADD_PRODUCT_TO_DRAFT_ORDERS,
         payload: boolean
      })
   };

export const setHasPrivateReplyAddress = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_HAS_PRIVATE_REPLY_ADDRESS,
         payload: boolean
      })
   };

export const setHasAskPhoneNumber = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_HAS_ASK_PHONE_NUMBER,
         payload: boolean
      })
   };

export const setHasCommentWelcomeStartLive = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_HAS_COMMENT_WELCOME_START_LIVE,
         payload: boolean
      })
   };

export const setContentCommentWelcomeStartLive = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_CONTENT_COMMENT_WELCOME_START_LIVE,
         payload: string
      })
   };


export const setHasCommentIntroProduct = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_HAS_COMMENT_INTRO_PRODUCT,
         payload: boolean
      })
   };

export const setContentCommentIntroProduct = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_CONTENT_COMMENT_INTRO_PRODUCT,
         payload: string
      })
   };

export const setAutoCompleteLiveCampaign = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_AUTO_COMPLETE_LIVE_CAMPAIGN,
         payload: boolean
      })
   };

export const setHasLockCommentCloseSale = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_HAS_LOCK_COMMENT_CLOSE_SALE,
         payload: boolean
      })
   };

export const setIsNotIncreaseQuantityCartItem = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_IS_NOT_INCREASE_QUANTITY_CART_ITEM,
         payload: boolean
      })
   };

export const setHasOrderTimeCheckout = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_HAS_ORDER_TIME_CHECKOUT,
         payload: boolean
      })
   };

export const setOrderTimeCheckoutType = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_ORDER_TIME_CHECKOUT_TYPE,
         payload: boolean
      })
   };

export const setLimitTimeOrderCheckout = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_LIMIT_TIME_ORDER_CHECKOUT,
         payload: boolean
      })
   };

export const setHasReminderCheckout = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_HAS_REMINDER_CHECKOUT,
         payload: boolean
      })
   };

export const setContentReminderCheckout = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_CONTENT_REMINDER_CHECKOUT,
         payload: string
      })
   };

export const setReminderCheckoutTimes = (boolean) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_REMINDER_CHECKOUT_TIMES,
         payload: boolean
      })
   };

export const setButtonReminderCheckout = (string) =>
   async (dispatch) => {
      dispatch({
         type: SETTING_PAGE_TYPE.SET_BUTTON_REMINDER_CHECKOUT,
         payload: string
      })
   };

export const fetchLiveSettingPageInfo = (campaign_id = 0) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime(),
         campaign_cate: 0,
         campaign_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.PAGE_SETTING_INFO}?${qs}`
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: SETTING_PAGE_TYPE.FETCH,
            payload: response.data
         })
      }).catch((error) => {
         dispatch(setError(error.message))
      })
   };


export const postLiveSettingPageInfo = (campaign_id = 0) =>
   async (dispatch, getState) => {
      const { settingPage, page } = getState();
      const params = {
         ...settingPage,
         fb_page_id: page.social_id,
         campaign_cate: 0,
         campaign_id
      }
      dispatch(showLoading());
      apiConfig.post(END_POINT.PAGE_SETTING, params).then(() => {
         showSuccessToasts('Lưu cấu hình thành công');
      }).catch((error) => {
         dispatch(setError(error.message))
      }).finally(() => dispatch(hideLoading()));
   };